type Translation = {
    language: string;
    name: string;
    description?: string;
};
export enum EVENT_TYPE {
    LPR_CAMERA_DETECTION = 'lpr_camera_detection',
    ACCESS_KEY_READER_DETECTION = 'access_key_reader_detection',
    IDENTIFIER_CREATED = 'identifier_created',
    VISITOR_IDENTIFIED = 'visitor_identified',
    GATEWAY_PASS_ALLOWED = 'gateway_pass_allowed',
    GATEWAY_PASS_NOT_ALLOWED = 'gateway_pass_not_allowed',
    ACTIVE_STAY_CREATED = 'active_stay_created',
    ACTIVE_STAY_PERIOD_CREATED = 'active_stay_period_created',
    ACTIVE_STAY_PERIOD_COMPLETED = 'active_stay_period_completed',
    ACTIVE_STAY_COMPLETED = 'active_stay_completed',
    ACTIVE_STAY_PAID = 'active_stay_paid',
    GATEWAY_OPENED = 'gateway_opened',
    GATEWAY_CLOSED = 'gateway_closed',
    SEND_GATEWAY_OPEN_COMMAND = 'send_gateway_open_command',
    SEND_GATEWAY_CLOSE_COMMAND = 'send_gateway_close_command',
}

export enum MAIN_IDENTIFIER_TYPE {
    LICENSE_PLATE = 'license_plate',
    TICKET = 'ticket',
    ACCESS_KEY = 'access_key',
}

type Identifier = {
    value: string;
    type: MAIN_IDENTIFIER_TYPE;
};

type Visitor = {
    id: string;
    main_identifier: Identifier;
};

type Gateway = {
    id: string;
    translations: Translation[];
};

type AccessKeyReaderDetection = {
    access_key_value: string;
};

export type GatewayOpened = {
    gateway: {
        id: string;
        names: Translation[];
    };
    reason: string;
};

type LPRCameraDetection = {
    license_plate: string;
    photo: string;
};

type ActiveStayCompleted = {
    past_stay_id: string;
    past_stay_ref: string;
};

type ActiveStayCreated = {
    ref: string;
    identifiers: Identifier[];
    visitor: Visitor;
    membership: {
        id: string;
        name: string;
    };
};

type ActiveStayPeriod = {
    active_stay_id: string;
    active_stay_ref: string;
    active_stay_period_id: string;
};

type ActiveStayPeriodCompleted = ActiveStayPeriod;

type ActiveStayPeriodCreated = ActiveStayPeriod;

export type GatewayClosed = {
    gateway: {
        id: string;
        names: Translation[];
    };
    reason: string;
};

export type SendGatewayCommand = {
    gateway: {
        id: string;
        names: Translation[];
    };
    reason?: string;
};

export enum GATEWAY_PASS_NOT_ALLOWED_REASON {
    IDENTIFIER_NOT_WHITELISTED = 'identifier_not_whitelisted',
    REQUIRED_IDENTIFIERS_NOT_COLLECTED = 'required_identifiers_not_collected',
    REQUIRED_IDENTIFIERS_NOT_VALID = 'required_identifiers_not_valid',
    ACTIVE_PERIOD_WITH_ACCESS_KEY = 'active_period_with_access_key',
    MEMBERSHIP_NOT_FOUND = 'membership_not_found',
    MEMBERSHIP_STARTING_IN_FUTURE = 'membership_starting_in_future',
    MEMBERSHIP_EXPIRED = 'membership_expired',
    RESTRICTED_GATEWAY_BY_MEMBERSHIP_TYPE = 'restricted_gateway_by_membership_type',
    MISSING_MEMBERSHIP_ZONE_RULE = 'missing_membership_zone_rule',
    OUTSIDE_ALLOWED_TIME_FRAME = 'outside_allowed_time_frame',
    NO_FREE_SPACES = 'no_free_spaces',
    RESERVED_SPACE = 'reserved_space',
    ALLOWED_SPACE = 'allowed_space',
    EXTRA_VISITOR_ALLOWED = 'extra_visitor_allowed',
    ALL_MEMBERSHIP_SPACES_USED = 'all_membership_spaces_used',
    ACCESS_KEY_NOT_EXISTS = 'access_key_not_exists',
    UNUSED_TICKET_NOT_EXISTS = 'unused_ticket_not_exists',
    VALID_IDENTIFIER_NOT_EXISTS = 'valid_identifier_not_exists',
    CLIENT_NOT_ALLOWED_IN_ENTRY_ZONE = 'client_not_allowed_in_entry_zone',
    ZONE_NOT_WORKING = 'zone_not_working',
    ZONE_CLIENT_CAPACITY_REACHED = 'zone_client_capacity_reached',
    ZONE_NO_FREE_SPACES = 'zone_no_free_spaces',
    GATEWAY_DOES_NOT_ALLOW_UNKNOWN_MAIN_IDENTIFIER = 'gateway_does_not_allow_unknown_main_identifier',
    UNKNOWN = 'unknown',
}

type GatewayPassNotAllowed = {
    gateway: Gateway;
    identifiers: Identifier[];
    visitor: Visitor;
    membership: {
        id: string;
        name: string;
    };
    reason: GATEWAY_PASS_NOT_ALLOWED_REASON;
};

type GatewayPassAllowed = {
    gateway: Gateway;
    identifiers: Identifier[];
    visitor: Visitor;
    membership: {
        id: string;
        name: string;
    };
};

type IdentifierCreated = {
    value: string;
    identifier_type: MAIN_IDENTIFIER_TYPE;
    identifier_id: string;
};

type VisitorIdentified = {
    identifiers: Identifier[];
    visitor: Visitor;
    created: boolean;
};
export type EventData =
    | AccessKeyReaderDetection
    | GatewayOpened
    | LPRCameraDetection
    | ActiveStayCompleted
    | ActiveStayCreated
    | ActiveStayPeriodCompleted
    | ActiveStayPeriodCreated
    | GatewayClosed
    | GatewayPassNotAllowed
    | GatewayPassAllowed
    | IdentifierCreated
    | VisitorIdentified
    | SendGatewayCommand;

export type EventLog = {
    id: string;
    event_data: EventData;
    created_at: string;
    modified_at: string;
    event_type: EVENT_TYPE;
    timestamp: string;
    user: string | null;
    gateway: Gateway | null;
    zone: string | null;
    system_component: string | null;
};
